import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "reactstrap";
import { useVisible } from "../../../utils/hooks/useVisible";

function BulkActions({ rows, selectedRows = [], batchRemove, canDelete }) {
	const { t } = useTranslation();
	const { visible, toggle } = useVisible();

	const ids = useMemo(() => {
		return Object.keys(rows);
	}, [rows]);

	const canDeleteRow = useCallback(
		(row) => (typeof canDelete === "function" ? canDelete(row) : true),
		[canDelete],
	);

	const canDeleteAll = useMemo(() => {
		if (ids.length === 0) {
			return false;
		}
		if (!selectedRows || selectedRows.length === 0) {
			return false;
		}
		return selectedRows.every(canDeleteRow);
	}, [ids.length, selectedRows, canDeleteRow]);

	const remove = useCallback(() => {
		batchRemove(ids);
	}, [ids, batchRemove]);

	return (
		<Dropdown isOpen={visible} toggle={toggle}>
			<span className="text-sm font-weight-600 text-dark mr-1 text-center">
				{t("selected")}{" "}
				<span
					className="text-sm rounded-circle py-1 px-2 mx-1"
					style={{ backgroundColor: "#ced4da" }}
				>
					{Object.keys(rows).length}
				</span>
			</span>

			<DropdownToggle
				className="btn-round btn-icon shadow-none border"
				size="sm"
			>
				{t("actions")}
			</DropdownToggle>

			<DropdownMenu>
				<DropdownItem onClick={remove} disabled={!canDeleteAll || !batchRemove}>
					{t("delete")}
				</DropdownItem>
			</DropdownMenu>
		</Dropdown>
	);
}

export default BulkActions;
